
import React, { useEffect, useState } from 'react';
import { IoLocationOutline } from "react-icons/io5";
import { MdOutlineDateRange } from "react-icons/md";
import { GoPerson } from "react-icons/go";
import { userUid } from '../../../../utils/storage';
import SittingService from '../../../Service/SittingService';
import { showErrorToast, showSuccessToast } from '../../../../components/Constant/Notification';
import { formatDate } from '../../../../utils/dateFormatter';
import ReusableSittingForm from '../../../OverallSittingManagement/ReusableSittingForm';
import SittingStatusModal from '../../../OverallSittingManagement/SittingStatusModal';
import { ToastContainer } from 'react-toastify';

const AcresAndCentsSittingInfo = ({propertyId}) => {
 
  const [sittingsByStatus, setSittingsByStatus] = useState({
    upcoming: { data: [], count: 0 },
    noUpdate: { data: [], count: 0 },
    completed: { data: [], count: 0 },
    cancelled: { data: [], count: 0 },
  });

    const [selectedSittingData, setSelectedSittingData] = useState({});
  const [isCancelled, setIsCancelled] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  
  const [isEditMode , setIsEditMode] = useState(false);
  const [statusCounts, setStatusCounts] = useState(0)
  const [loading, setLoading] = useState({
    upcoming: false,
    noUpdate: false,
    completed: false,
    cancelled: false
  });

  const [showSittingForm, setShowSittingForm] = useState(false);
  const [editingSitting, setEditingSitting] = useState(null);
  const [formData, setFormData] = useState({
    stage : "",
    sittingTitle: "",
    sittingSpot: "",
    primarySittingPerson: "",
    secondarySittingPerson: "",
    meetingPersonType: "",
    meetingPersonName: "",
    sittingDate: "",
    sittingTime: "",
    otherNotes: "",
    status: "",
    isCompleted : "",
    negotiatedAreaType : "",
    negotiatedAmount : "",
    advanceAmount : "",
    feedback : "", 
    cancellationReason : "",
    sittingId: ""
  });

  const handleCreateSitting = () => {
    setIsEditMode(true);
    setEditingSitting(null);
    setFormData({
      sittingTitle: "",
      sittingSpot: "",
      primarySittingPerson: "",
      secondarySittingPerson: "",
      meetingPersonType: "",
      meetingPersonName: "",
      sittingDate: "",
      sittingTime: "",
      otherNotes: ""
    });
    setShowSittingForm(true);
  };

  const handleEditSitting = async(sitting) => {
    setEditingSitting(sitting);
    try{

      const userDetails = await SittingService.getSittingById(propertyId,sitting.sittingId);
      const data = userDetails.data?.data || {};
      setFormData({
        isCompleted : data.isCompleted || "",
        stage: data.currentStatus || "",
        sittingTitle: data.title || "",
        sittingSpot: data.location || "",
        primarySittingPerson: data.primarySittingPerson ? {
          value: data.primarySittingPerson.id,
          label: data.primarySittingPerson.name
        } : "",
        secondarySittingPerson: data.secondarySittingPerson ? {
          value: data.secondarySittingPerson.id,
          label: data.secondarySittingPerson.name
        } : "",
        meetingPersonName: data.meetingPersonName || "",
        meetingPersonType: data.meetingPersonType || "",
        sittingDate : data.sittingDate || "",
        sittingTime : data.sittingTime || "",
        otherNotes: data.notes || "",
        status: data.isCompleted || "",
        negotiatedAreaType : data.negotiatedAreaType || "",
        negotiatedAmount : data.negotiatedAmount || "",
        advanceAmount : data.advanceAmount || "",
        feedback : data.feedback || "",
        cancellationReason : data.cancellationReason || ""
        
      });
    }catch(error){
      console.error("Error fetching sitting details:", error);
    }
   
    setShowSittingForm(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  
  const fetchSittingsForStatus = async (status) => {
    try {
      setLoading(prev => ({ ...prev, [status]: true }));
      const body = {
        propertyId: propertyId,
        limit: 10,
        status: status,
        startAfter: ""
      };
      const response = await SittingService.getSittings(body);
     
      const data = response.data?.data || {};
      if (response.data && data?.sittings) {
        setSittingsByStatus(prev => ({
          ...prev,
          [status]: {
            data: data.sittings || [],
            count: data.aggregation?.totalSittings || 0
          }
        }));
      }
      
    } catch (error) {
      console.error(`Error fetching ${status} sittings:`, error);
    } finally {
      setLoading(prev => ({ ...prev, [status]: false }));
    }
  };

 
  const fetchAllSittings = async () => {
   
    
    await Promise.all([
      fetchSittingsForStatus('upcoming'),
      fetchSittingsForStatus('noUpdate'),
      fetchSittingsForStatus('completed'),
      fetchSittingsForStatus('cancelled')
    ]);
  };

  useEffect(() => {
    if (propertyId) {
      fetchAllSittings();
    }
  }, [propertyId]);


   const handleValidation = () => {
     if(!formData.sittingTitle?.trim()) {
       showErrorToast("Sitting Title is required");
       return false;
     }
     if(!formData.sittingDate) {
       showErrorToast("Sitting Date is required");
       return false;
     }
     if(!formData.sittingTime) {
       showErrorToast("Sitting Time is required");
       return false;
     }
     if(!formData.sittingSpot?.trim()) {
       showErrorToast("Sitting Spot is required");
       return false;
     }
      if(!formData.primarySittingPerson) {
             showErrorToast("Primary Sitting Person is required");
             return false;
           }
 
     return true;
 
   }
  

  const handleFormSubmit = async (status) => {

    if(status === "COMPLETED"){
      setIsCompleted(true);
      setShowSittingForm(false);

      return;
    }
    if(status === "CANCELLED"){
      setIsCancelled(true);
      setShowSittingForm(false);
      return;
    }
    if (!handleValidation()) {
      return;
    }
    if (editingSitting) {
      try {
        const body = {
          sittingId: editingSitting.sittingId,
          propertyId: propertyId,
          title: formData.sittingTitle,
          sittingDate: formData.sittingDate,
          sittingTime : formData.sittingTime,
          location: formData.sittingSpot,
          primarySittingPerson: formData.primarySittingPerson?.value,
          secondarySittingPerson: formData.secondarySittingPerson?.value,
          meetingPersonType: formData.meetingPersonType,
          meetingPersonName: formData.meetingPersonName,
          notes: formData.otherNotes,
          isCompleted: status,
          modifiedById: userUid
        };
       
        const response = await SittingService.updateSitting(body);
        const updatedSitting = response.data;
        if (updatedSitting) {
          showSuccessToast(updatedSitting?.message || "Sitting updated successfully");
          setShowSittingForm(false);
       
          fetchAllSittings();
        }
      } catch (error) {
        console.error("Error updating sitting:", error);
      }
    
    } else {
      try {
        const body = {
          propertyId: propertyId,
          title: formData.sittingTitle,
          sittingDate: formData.sittingDate,
          sittingTime : formData.sittingTime,
          location: formData.sittingSpot,
          primarySittingPerson: formData.primarySittingPerson?.value,
          secondarySittingPerson: formData.secondarySittingPerson?.value,
          meetingPersonType: formData.meetingPersonType,
          meetingPersonName: formData.meetingPersonName,
          notes: formData.otherNotes,
          createdById: userUid
        };
        const response = await SittingService.createSitting(body);
        const newSitting = response.data;

     

        if (newSitting) {
          showSuccessToast(newSitting?.message || "Sitting created successfully");
          setShowSittingForm(false);
          fetchAllSittings();
        }
      } catch (error) {
        console.error("Error adding new sitting:", error);
      }
    }
    setShowSittingForm(false);
  };



  // Handle status update callback from SittingStatusModal
  const handleStatusUpdate = () => {
    fetchAllSittings();
  };

  const getStatusConfig = (status) => {
    switch (status) {
      case 'upcoming':
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          headerBg: 'bg-blue-100',
          textColor: 'text-blue-800',
          countColor: 'text-blue-600',
          cardBg: 'bg-white',
          cardBorder: 'border-blue-100',
          icon: '🕒'
        };
      case 'noUpdate':
        return {
          bg: 'bg-orange-50',
          border: 'border-orange-200',
          headerBg: 'bg-orange-100',
          textColor: 'text-orange-800',
          countColor: 'text-orange-600',
          cardBg: 'bg-white',
          cardBorder: 'border-orange-100',
          icon: '⏳'
        };
      case 'completed':
        return {
          bg: 'bg-green-50',
          border: 'border-green-200',
          headerBg: 'bg-green-100',
          textColor: 'text-green-800',
          countColor: 'text-green-600',
          cardBg: 'bg-white',
          cardBorder: 'border-green-100',
          icon: '✅'
        };
      case 'cancelled':
        return {
          bg: 'bg-red-50',
          border: 'border-red-200',
          headerBg: 'bg-red-100',
          textColor: 'text-red-800',
          countColor: 'text-red-600',
          cardBg: 'bg-white',
          cardBorder: 'border-red-100',
          icon: '❌'
        };
      default:
        return {
          bg: 'bg-gray-50',
          border: 'border-gray-200',
          headerBg: 'bg-gray-100',
          textColor: 'text-gray-800',
          countColor: 'text-gray-600',
          cardBg: 'bg-white',
          cardBorder: 'border-gray-100',
          icon: '📋'
        };
    }
  };

  const KanbanColumn = ({ status, title, count }) => {
    const config = getStatusConfig(status);
    const columnSittings = sittingsByStatus[status] || [];
    const isLoading = loading[status];



    return (
      <div className="min-w-[360px] flex-shrink-0"> 
        <div className={`px-2 py-2 rounded-t-xl`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <h3 className={`font-semibold ${config.textColor}`}>{title}</h3>
            </div>
            <span className={`${config.countColor} font-bold text-sm bg-white px-2 py-1 rounded-full`}>
              ({count})
            </span>
          </div>
        </div>
        <div className={`${config.bg} ${config.border} border rounded-xl h-[calc(100vh-270px)] overflow-y-auto flex flex-col`}>
          {/* Column Content */}
          <div className="flex-1 p-3 space-y-3">
            {isLoading ? (
              <div className="flex flex-col items-center justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="text-sm text-gray-500 mt-2">Loading...</p>
              </div>
            ) : (
              <>
                {columnSittings?.data.map(sitting => {
                 
                  return (
                    <div
                      key={sitting.sittingId}
                      className={`${config.cardBg} ${config.cardBorder} border rounded-lg p-4 cursor-pointer 
                                hover:shadow-md hover:-translate-y-1 transition-all duration-200`}
                      onClick={() => 
                        {handleEditSitting(sitting)
                        setSelectedSittingData(sitting);
                        }
                      }
                    >
                      <div className="mb-3 w-[230px]">
                        <h4 className="font-semibold line-clamp-2 text-wrap truncate text-gray-800 text-base leading-snug">
                          {sitting.title}
                        </h4>
                      </div>
                      <div className="mb-3">
                        <div className="flex items-center gap-2">
                          <GoPerson className="text-blue-400 text-lg flex-shrink-0" />
                          <div className="flex flex-col text-xs">
                            <span className="text-gray-700 font-medium truncate">
                              {sitting.primarySittingPerson?.name} ({sitting.primarySittingPerson?.role})
                            </span>
                            {sitting.secondarySittingPerson?.name && (
                              <span className="text-gray-600 truncate">
                                {sitting.secondarySittingPerson.name} ({sitting.secondarySittingPerson.role})
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="mb-3 flex items-center gap-3 text-xs text-gray-500">
                        <div className="flex items-center gap-1">
                          <MdOutlineDateRange className="text-blue-400 text-lg flex-shrink-0" />
                          <span>{sitting?.sittingDate}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <span>{sitting?.sittingTime}</span>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <IoLocationOutline className="text-blue-400 text-lg flex-shrink-0" />
                        <span className="truncate">{sitting.location}</span>
                      </div>
                    </div>
                  );
                })}
                {columnSittings.length === 0 && !isLoading && (
                  <div className="flex flex-col items-center justify-center py-8 text-gray-400">
                    <p className="text-sm">No {title.toLowerCase()} sittings</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="">
      <ToastContainer/>
      {/* Header with Create Button */}
      <div className="flex justify-between items-center">
        <div></div>
        <button
          onClick={handleCreateSitting}
          className="absolute right-4 top-7 bg-customGreen text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors flex items-center gap-2"
        >
          Create Sitting
        </button>
      </div>

      {/* Kanban Board */}
      <div className="flex overflow-x-auto gap-4">
        <KanbanColumn 
          status="upcoming" 
          title="Upcoming" 
          count={sittingsByStatus.upcoming.count} 
        />
        <KanbanColumn 
          status="noUpdate" 
          title="No Update" 
          count={sittingsByStatus.noUpdate.count} 
        />
        <KanbanColumn 
          status="completed" 
          title="Completed" 
          count={sittingsByStatus.completed.count} 
        />
        <KanbanColumn 
          status="cancelled" 
          title="Cancelled" 
          count={sittingsByStatus.cancelled.count} 
        />
      </div>

      

      {/* Sitting Form Modal */}
      <ReusableSittingForm
        visible={showSittingForm}
        isEditMode={isEditMode}
        editingSitting={editingSitting}
        setFormData={setFormData}
        onHide={() => {
          setShowSittingForm(false)
          setIsEditMode(false);
          setFormData({
            stage : "",
            sittingTitle: "",
            sittingSpot: "",
            primarySittingPerson: "",
            secondarySittingPerson: "",
            meetingPersonType: "",
            meetingPersonName: "",
            sittingDate: "",
            sittingTime: "",
            otherNotes: "",
            status: "",
            isCompleted : ""
          })
        }}
        onSubmit={handleFormSubmit}
        formData={formData}
        onChange={handleFormChange}
        title="Sitting"
        sidebarWidth="600px"
        showAdvancedButtons={true}
        customButtonLogic={(formData) => {
          const isUpcomingOrNoUpdate = 
            formData?.isCompleted === "Up Coming" || 
            formData?.isCompleted === "No Update";
          
          const isNotCompletedOrCancelled = 
            formData.isCompleted !== "COMPLETED" && 
            formData.isCompleted !== "CANCELLED";
          
          const canShowAdvancedButtons = 
            formData.stage !== "completed" && 
            formData.stage !== "cancelled";

          return {
            showPrimaryButton: (isUpcomingOrNoUpdate && canShowAdvancedButtons) || isEditMode || isNotCompletedOrCancelled,
            showCompletedButton: isUpcomingOrNoUpdate && canShowAdvancedButtons,
            showCancelButton: isUpcomingOrNoUpdate && canShowAdvancedButtons,
          };
        }}
      />
      {/* Reusable Sitting Status Modal */}
      <SittingStatusModal
        isCompletedOpen={isCompleted}
        setIsCompletedOpen={setIsCompleted}
        isCancelledOpen={isCancelled}
        setIsCancelledOpen={setIsCancelled}
        selectedSittingData={selectedSittingData}
        onStatusUpdate={handleStatusUpdate}
      />
    </div>
  );
};


export default AcresAndCentsSittingInfo;